import { Injectable } from '@angular/core';
import { Subject, Observable, of, map } from 'rxjs';
import { SocketService } from './socket.service';
import { ConfigService } from './config.service';
import { MessageResumeMarket } from '@model/webFeeder/message-resume-market';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';

@Injectable({ providedIn: 'root' })
export class ScktResumeMarketService {

  private serviceSubject = new Subject<MessageEvent>();
  messagesResumeMarket: Observable<any>;
  private _message: MessageResumeMarket[] = [];

  constructor(
    private _socketService: SocketService,
    private _configService: ConfigService
  ) { }

  public createSubject() {
    const newService = {
      name: 'ResumeIndexType',
      serviceSubject: this.serviceSubject
    };
    this._socketService.register(newService);
    this.messagesResumeMarket = newService.serviceSubject
      .pipe(map(data => {
        if (data.type === 'ResumeIndexType') {
          return {
            parameter: data['parameter'],
            type: data['type'],
            identifier: data['identifier'],
            list: data['streamingResumeIndexList'],
            errorMessage: ''
          };
        }
        if (data.type === 'ResumeMarketType') {
          return {
            parameter: data['parameter'],
            type: data['type'],
            identifier: data['identifier'],
            list: data['streamingResumeMarketList'],
            errorMessage: ''
          };
        }
        return data;
      })
      );
  }

  public unsubscribeResumeMarket(service: string, parameterGet: string) {
    if (service !== '' && service !== undefined) {
      const item = this._message.filter(x => x.identifier === service);
      if (item.length > 0) {
        item[0].count -= 1;
        if (item[0].count <= 0) {
          this.sendMessageResumeMarket('0', service, parameterGet);
          item[0].count = 0;
          this._configService.writeLog('UNSUBSCRIBE RESUME MARKET > [' + item[0].count + '][' + service.toUpperCase() + '] <<<<<');
        }
      }
    }
  }

  public subscribeResumeMarket(service: string, parameterGet: string) {
    if (service !== '' && service !== undefined) {
      const item = this._message.filter(x => x.identifier === service);
      let total = 0;

      if (item.length === 0) {
        this._message.push({
          identifier: service,
          parameter: parameterGet,
          count: 1,
          list: null
        });
      } else if (item.length > 0) {
        item[0].count += 1;
        total = item[0].count;
      }
      this.sendMessageResumeMarket('1', service, parameterGet);
      this._configService.writeLog('SUBSCRIBE RESUME MARKET > [' + total + '][' + service.toUpperCase() + '] <<<<<');
    }
  }

  private sendMessageResumeMarket(type: string, service: string, parameterGet: string) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this._configService.getToken();
    dataMsg.module = 'quotes';
    dataMsg.service = service;
    dataMsg.parameterGet = parameterGet; //ibxx
    dataMsg.parameters = { 'subsbribetype': type, 'typecommand': 'index' };
    setTimeout(() => {
      this._socketService.signService(dataMsg);
    }, 1000);
  }


}
